<script>
  import getSectorNames from "../../helpers/getSectorNames";
  import findSector from "../../helpers/findSector";
  import FeaturedLinks from "./FeaturedLinks.svelte";

  // Props
  export let report;

  // Constant
  const foundSummaryReport = report?.summaryId
    ? WP.summaryIdMap.find((summary) => {
        return summary.id === report.summaryId;
      })
    : null;

  // Conditional
  let imgSrc = "";
  $: {
    if (report) {
      imgSrc = report.featuredImage
        ? `data:image/jpeg;base64,${report.featuredImage}`
        : null;

      // Use sector image if no image available
      const fullImg =
        !imgSrc && report.sectorIds.length
          ? findSector("id", report.sectorIds[0], "spotlightImage")
          : null;
      if (!imgSrc && fullImg) {
        const temp = document.createElement("div");
        temp.innerHTML = fullImg;
        imgSrc = temp.querySelector("img").src;
      }
    }
  }
</script>

<div class="wrapper">
  {#if report}
    <div
      class="background"
      style={`
          background-image:
            linear-gradient(89.72deg, rgba(255, 255, 255, 0.95) 52.38%, rgba(255, 255, 255, 0) 99.68%),
            url(${imgSrc});
        `}
    />
    <div class="spotlight-content">
      <h2 class="featured-reports-heading">Featured Reports</h2>

      <p id="first-report-sector">
        {getSectorNames(report.sectorIds || [])}
      </p>

      <h3 id="first-report-title">{report.title}</h3>
      <p id="first-report-desc">{report.description}</p>
      <FeaturedLinks
        reportLink={report.url}
        summaryLink={foundSummaryReport ? foundSummaryReport.slug : null}
        podcastLink={report.podcastUrl || null}
      />
    </div>
  {/if}
</div>

<style>
  .wrapper {
    flex-basis: 57%;
    position: relative;
  }

  .background {
    position: absolute;
    right: 0;
    height: 100%;
    width: calc(1356px * 0.57 + (100vw - 1356px) / 2);
    z-index: -1;
    background-color: #ffffff;
    background-size: cover;
    background-position: center;
  }
  @media screen and (max-width: 1416px) {
    .wrapper {
      flex-basis: 50%;
    }
    .background {
      width: 50vw;
    }
  }
  @media screen and (max-width: 1080px) {
    .wrapper {
      padding: 0 70px;
      width: 100vw;
      position: relative;
      left: -30px;
    }
    .background {
      width: 100vw;
    }
  }

  .spotlight-content {
    padding-top: 17.6%; /* 136px @ full 773 width */
    padding-bottom: 13.1%; /* 101px @ full 773 width */
    max-width: 420px;
  }

  #first-report-sector {
    color: #6b6e6f;
    font-family: "Georgia";
    font-weight: 400;
    font-style: normal;
    font-size: 18px;
    line-height: 24px;
  }

  #first-report-title {
    color: #3d4042;
    font-family: "Segoe UI", sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: 24px;
    line-height: 30px;
  }

  #first-report-desc {
    color: #4a4a4a;
    font-family: "Segoe UI", sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 24px;
  }

  .featured-reports-heading {
    font-family: "Georgia";
    font-size: 32px;
    font-size: 3.2rem;
    line-height: 42px;
    line-height: 4.2rem;
    font-style: normal;
    font-weight: 400;
    color: #0e4369;
    padding-top: 0;
    padding-bottom: 20px;
  }
</style>
